export const MEETING_DATE_UPDATED = "meeting_date_Updated";
export const MEETING_LAST_UPLOAD_UPDATED = "meeting_last_upload_Updated";
export const MEETING_STUDY_PERIOD_UPDATED = "meeting_study_period_updated";
export const MEETING_NUMBER_UPDATED = "meeting_number_updated";
